<div class="terms-container">
    <header class="terms-header">
        <button (click)="goBack()" class="me-2 back-button">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <h1>Terms and Conditions</h1>
        <div class="meta-data">
            <p><strong>Effective Date:</strong> 20 Nov 2025</p>
            <p><strong>Entity:</strong> Vijayi WFH Technologies Private Limited</p>
        </div>
    </header>

    <main class="terms-content">
        <p class="intro-text">
            This is an agreement (“Agreement”) between you and Vijayi WFH Technologies Private Limited (“Company”, “we”,
            “us”, or “our”). You may enter into this Agreement on behalf of yourself or on behalf of a legal entity. If
            you enter into this Agreement on behalf of a legal entity, you confirm that you are authorized to bind that
            entity to this Agreement. “You” refers to the individual user or the organization you represent.
        </p>
        <p>
            By downloading, accessing, or using the application TSe (including the web app, Android app, and iOS app)
            (“App”), you agree to be bound by this Agreement.
        </p>
        <div class="warning-box">
            <p><strong>Note:</strong> Use of the App constitutes acceptance of these Terms. Violation of any provision
                may result in penalties or termination of access. If you use the App as an employee/contractor of a
                company, that company will be responsible for penalties or liabilities if you fail to pay them. All
                legal matters will fall under the exclusive jurisdiction of Gurugram (Haryana), India.</p>
        </div>

        <section>
            <h2>1. Intellectual Property</h2>
            <p>The App, including its code, design, features, content, trademarks, and associated intellectual property,
                is the exclusive property of the Company.</p>
        </section>

        <section>
            <h2>2. Ethical Usage of the App</h2>
            <p>You agree to use the App ethically and lawfully. Ethical usage includes compliance with applicable laws,
                respecting intellectual property, avoiding fraudulent or malicious activity, and using the App only for
                its intended purposes such as task management, project management, collaboration, productivity
                enhancement, HR management, and related functions.</p>
            <p>Some App features may involve optional data inputs such as location data for Geo-Fencing, integration
                tokens for GitHub or JIRA, or optional usage of AI-assisted features. When using these features, you are
                responsible for ensuring that such usage complies with your organization’s internal policies.</p>
        </section>

        <section>
            <h2>3. Prohibited Activities</h2>
            <p>You agree not to:</p>
            <ul>
                <li>Copy, replicate, modify, reverse engineer, decompile, or create derivatives of any part of the
                    App.
                </li>
                <li>Use the App for competitive analysis or disclose App functionality to competitors or entities
                    attempting to build a similar product.
                </li>
                <li>Extract source code or translate the App into another language.</li>
                <li>Provide access to features or information to individuals or entities developing competing
                    software.
                </li>
                <li>Upload viruses, harmful files, or malicious content.</li>
                <li>Harm the App, its users, its reputation, or the Company in any manner.</li>
                <li>Crawl, scrape, hack, or attempt unauthorized access to the App.</li>
                <li>Post inappropriate, hateful, abusive, political, or religiously harmful content.</li>
            </ul>
            <p>You are fully liable for damages caused by malicious files or misuse, whether intentional or
                unintentional.</p>
        </section>

        <section>
            <h2>4. Reporting Security Issues</h2>
            <p>If you discover any security vulnerability, unauthorized access, misuse, or harmful activity related to
                the App, you must promptly inform us through the contact details provided on our website (<a
                        href="https://vijayiwfh.com" target="_blank">https://vijayiwfh.com</a>) or via email at <a
                        href="mailto:rohit.nagpal@vijayi-wfh.com">rohit.nagpal&#64;vijayi-wfh.com</a>.</p>
        </section>

        <section>
            <h2>5. Changes and Charges</h2>
            <p>The Company may update features, change functionality, or introduce paid services at any time. If future
                charges apply, users will receive prior communication. We continuously enhance the App to improve
                usefulness and efficiency.</p>
        </section>

        <section>
            <h2>6. Security Measures</h2>
            <p>The App stores and processes personal and organizational data you provide.</p>
            <ul>
                <li>You are responsible for maintaining device security, including OS updates, secure passwords, and
                    preventing unauthorized access.
                </li>
                <li>Using a rooted or jailbroken device can compromise app security and may cause the App to malfunction
                    or become unusable. The Company is not responsible for issues arising from insecure or modified
                    devices.
                </li>
            </ul>
        </section>

        <section>
            <h2>7. Third-Party Services</h2>
            <p>The App may use third-party services for hosting, analytics, notifications, crash reporting, or
                feature-specific processing. These services have their own Terms & Conditions and Privacy Policies,
                which you must comply with when using the App.</p>

            <div class="info-box">
                <h3>Important:</h3>
                <ul>
                    <li>When connecting to platforms such as GitHub or JIRA, the App does not share your personal or
                        organizational data with them.
                    </li>
                    <li>These integrations are strictly one-way, meaning we only fetch data (e.g., repositories, issues)
                        as authorized by you.
                    </li>
                    <li>Any location-based features (e.g., Geo-Fence) require device permissions and organizational
                        enablement.
                    </li>
                </ul>
            </div>
        </section>

        <section>
            <h2>8. Limitation of Liability</h2>
            <p>You are responsible for your device, internet connection, storage, permissions, and the environment in
                which the App operates.</p>
            <p>The Company is not liable for:</p>
            <ul>
                <li>Loss of data due to device malfunction, battery drain, OS issues, or theft.</li>
                <li>Unavailability of the App caused by network issues or third-party service failures.</li>
                <li>Losses arising from reliance on data fetched from third-party systems (e.g., GitHub, JIRA).</li>
                <li>Any direct or indirect loss caused by data breaches, hacks, or service downtime, despite the
                    Company’s reasonable security efforts.
                </li>
            </ul>
            <p>You agree not to initiate or participate in any class action lawsuit against the App or the Company.</p>
        </section>

        <section>
            <h2>9. Cookies, Local Storage (Web App)</h2>
            <p>By using the web version of the App, you consent to the use of cookies, local storage for session
                management, security, and feature functionality.</p>
        </section>

        <section>
            <h2>10. Termination and Updates</h2>
            <p>We may terminate access or block users at any time, with or without notice.</p>
            <p>Upon termination:</p>
            <ul>
                <li>All rights granted to you will end.</li>
                <li>You must stop using the App and uninstall it from your devices (for mobile apps).</li>
                <li>You must accept updates to continue using the App. The Company does not guarantee compatibility with
                    all current or future devices or operating systems.
                </li>
            </ul>
        </section>

        <section>
            <h2>11. Account and Organization Deletion</h2>
            <p>Users or organizations may request deletion of their accounts or organization data by contacting us.</p>
            <p>Upon deletion:</p>
            <ul>
                <li>User/organization data will be removed from active systems within a defined period.</li>
                <li>The Company may retain certain records only as required by applicable laws or for security, audit,
                    or backup purposes.
                </li>
            </ul>
        </section>

        <section>
            <h2>12. Changes to Terms</h2>
            <p>We may update these Terms periodically. You are advised to review this page for changes. Continued use
                after updates implies acceptance.</p>
        </section>

        <section>
            <h2>13. Governing Laws</h2>
            <p>This Agreement is governed by the laws of India, and all disputes are subject to the exclusive
                jurisdiction of the Gurugram (Haryana) courts.</p>
        </section>

        <section id="contact">
            <h2>Contact Us</h2>
            <p>For questions or suggestions regarding this Agreement, contact us at:</p>
            <address>
                <strong>Vijayi WFH Technologies Private Limited</strong><br>
                Email: <a href="mailto:rohit.nagpal@vijayi-wfh.com">rohit.nagpal&#64;vijayi-wfh.com</a>
            </address>
        </section>
    </main>
</div>